
export default class TwoDimensionStrategy {
  constructor ({ productStrategy, storeStrategy }) {
    this.productStrategy = productStrategy
    this.storeStrategy = storeStrategy
  }

  build () {
    const productStrategyPayloadParameters = this.productStrategy.build()
    const storeStrategyPayloadParameters = this.storeStrategy.build()
    delete productStrategyPayloadParameters.storeFilters
    delete storeStrategyPayloadParameters.productFilters
    const twoDimensionStrategy = ({ ...productStrategyPayloadParameters, ...storeStrategyPayloadParameters })
    return twoDimensionStrategy
  }
}



// WEBPACK FOOTER //
// ./src/app/sales_analysis/models/TwoDimensionStrategy.js